module.exports = __webpack_public_path__ + "14ee0abc474f44d827ccf0c5250bdfc4.svg";